/**
 * @description  Session type available
 */

export default Object.freeze({
  BOT: 'BOT', // Bot provider (Dydu, ...)
  CHAT: 'CHAT', // Twilio chat
  QUEUING: 'QUEUING', // Queuing before Twilio chat
  SATISFACTION: 'SATISFACTION',
})
